export const ApiDef_OrderGroup = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map